module.exports = __webpack_public_path__ + "static/img/Aaclogo1.8e15f67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aaclogo1.png
// module id = OpA0
// module chunks = 1